module.exports = __webpack_public_path__ + "img/xiuzheng.293b82f7.png";